@use "@fukuri-admins/ui/layout" as *;

.container {
  padding: 20px;
  background-color: background('Senary');
  border-radius: borderRadius('xl');
  // PaymentElement 全体の幅を 336px 相当に制約
  max-width: 336px;
}
